import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { SYSTEM_PILLARS } from './salesData';
const NOT_THIS: string[] = ['Sin invertir más en publicidad', 'Sin bajar los precios de tus tratamientos', 'Sin agregar más horas de sillón'];
export function PositioningSection() {
  return <section className="bg-sand py-12 sm:py-16" data-id="element-295" data-mp="v3px7o6twpyz">
      <div className="mx-auto max-w-4xl px-5" data-id="element-296" data-mp="q7iojnn1t0dc">
        <div className="text-center" data-id="element-297" data-mp="q44q2qhi9bb6">
          <SectionTag data-id="element-298" data-mp="m4mdchzu86jf">La idea central</SectionTag>
          <h2 className="mt-4 font-display text-[1.5rem] font-bold uppercase leading-tight text-charcoal sm:text-[2.15rem]" data-id="element-299" data-mp="m6yw2xdf6kxj">
            Antes de buscar más pacientes,
            <span className="mt-1 block text-gold-deep" data-id="element-300" data-mp="c7zt9vfc5jig">hay que cerrar las fugas</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl font-sans text-sm leading-relaxed text-charcoal/70 sm:text-base" data-id="element-301" data-mp="2biheb4yiyasz">
            Tu consultorio ya genera oportunidades todos los días: consultas, turnos, diagnósticos y
            presupuestos. El problema es que una parte importante se pierde en el camino. Cerrar esas
            fugas es más rápido, más barato y más rentable que salir a buscar más pacientes.
          </p>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2" data-id="element-302" data-mp="1viotz9y2ewys">
          {NOT_THIS.map(item => <li key={item} className="inline-flex items-center gap-1.5 rounded-full border border-stone bg-ivory px-3.5 py-1.5 font-sans text-[0.72rem] font-medium text-charcoal/70" data-id="element-303" data-mp="2o5164buy3rnz">
              <XIcon className="h-3.5 w-3.5 shrink-0 text-charcoal/40" aria-hidden data-id="element-304" data-mp="2efpxsrfvur15" />
              {item}
            </li>)}
        </ul>

        <h3 className="mt-9 text-center font-display text-lg font-bold uppercase leading-tight text-charcoal sm:text-2xl" data-id="element-305" data-mp="2jcgi5qyq08sd">
          Las 5 fugas por donde se escapa la rentabilidad
        </h3>

        <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-5" data-id="element-306" data-mp="3bvwtmwsdc0pf">
          {SYSTEM_PILLARS.map((pillar, i) => <motion.article key={pillar.title} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.35,
          delay: i * 0.05
        }} className="rounded-xl border border-stone bg-ivory p-4" data-id="element-307" data-mp="3lo83lcun30z2" data-mpi={i}>
              <p className="font-sans text-[0.6rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-308" data-mp="32shxpejl5kfw">
                Fuga 0{i + 1}
              </p>
              <h4 className="mt-1.5 font-display text-base font-bold leading-tight text-charcoal" data-id="element-309" data-mp="2t1ncmdi2sqw1">
                {pillar.title}
              </h4>
              <p className="mt-1 font-sans text-[0.78rem] leading-snug text-charcoal/70" data-id="element-310" data-mp="2o4evmg8nyswd">
                {pillar.desc}
              </p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}